module.exports = __webpack_public_path__ + "assets/img/img322.7a32dce7.png";